import {
  SET_SEARCH_TERM,
  SET_SEARCH_QUERY_TYPE,
  SET_SEARCH_FIELDS,
  CLEAR_SEARCH_FIELDS,
} from '../actions/Search';

const initialState = {
  search: null,
  query_type: null,
  search_fields: [],
};

export const Search = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_TERM:
      return { ...state, search: action.search };

    case SET_SEARCH_QUERY_TYPE:
      return { ...state, query_type: action.searchQueryType };

    case SET_SEARCH_FIELDS:
      return { ...state, search_fields: action.searchFields };

    case CLEAR_SEARCH_FIELDS:
      return { ...state, search_fields: [] };

    default:
      return state;
  }
};
